<template>
    <NumberFlow :class="$props.class" :value="initialValue" :continuous="true" :suffix />
</template>

<script setup lang="ts">
import { ref, watch, type HTMLAttributes } from 'vue'
import NumberFlow from '@number-flow/vue'
import { useBlockContext } from '@/website/blocks/common/composables'

interface Props {
    value: number
    suffix?: string
    class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
const initialValue = ref(0)

const { isInView } = useBlockContext()!

watch(
    isInView,
    (newValue) => {
        if (newValue) {
            initialValue.value = props.value
        }
    },
    { immediate: true },
)
</script>

<style scoped>
number-flow-vue::part(suffix) {
    margin-left: 0.0625em;
    font-size: 1em;
    color: hsl(var(--yellow));
    /* @apply text-yellow; */
}
</style>
